import { render, staticRenderFns } from "./ChartSorter.vue?vue&type=template&id=66d5b8fc&scoped=true"
import script from "./ChartSorter.vue?vue&type=script&lang=js"
export * from "./ChartSorter.vue?vue&type=script&lang=js"
import style0 from "./ChartSorter.vue?vue&type=style&index=0&id=66d5b8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d5b8fc",
  null
  
)

export default component.exports